// SEO helpers — constantes site + générateurs de JSON-LD Schema.org
export const SITE_URL = "https://horssignal.com";
export const DEFAULT_IMG = `${SITE_URL}/logo512.png`;

export const truncate = (s, n = 160) => {
  const t = String(s || "").replace(/\s+/g, " ").trim();
  return t.length > n ? `${t.slice(0, n - 1).trimEnd()}…` : t;
};

// Préfixe les URLs d'images relatives (commençant par /) avec le domaine du site
export const absoluteImage = (img) => {
  if (!img) return DEFAULT_IMG;
  return img.startsWith("/") ? `${SITE_URL}${img}` : img;
};

export const orgJsonLd = {
  "@context": "https://schema.org",
  "@type": "TravelAgency",
  name: "HORS SIGNAL",
  url: SITE_URL,
  logo: DEFAULT_IMG,
  image: DEFAULT_IMG,
  description:
    "Agence d'expéditions extrêmes, rares et confidentielles, en très petits groupes (5 personnes maximum), encadrées par des guides experts.",
  email: "contact@horssignal.com",
  areaServed: "Worldwide",
  sameAs: ["https://instagram.com/wearehorssignal"],
};

export const websiteJsonLd = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "HORS SIGNAL",
  url: SITE_URL,
  inLanguage: "fr-FR",
};

export const breadcrumbJsonLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: `${SITE_URL}${it.path}`,
  })),
});

export const faqJsonLd = (pairs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: pairs
    .filter(([q, a]) => q && a)
    .map(([q, a]) => ({
      "@type": "Question",
      name: q,
      acceptedAnswer: { "@type": "Answer", text: a },
    })),
});

// exp: { slug, title(str), description(str), image, price, soldOut }
export const touristTripJsonLd = ({ slug, title, description, image, price, soldOut }) => {
  const ld = {
    "@context": "https://schema.org",
    "@type": "TouristTrip",
    name: title,
    description,
    image,
    url: `${SITE_URL}/expeditions/${slug}`,
    touristType: "Adventure",
    provider: { "@type": "Organization", name: "HORS SIGNAL", url: SITE_URL },
  };
  if (price) {
    ld.offers = {
      "@type": "Offer",
      price,
      priceCurrency: "EUR",
      availability: soldOut ? "https://schema.org/SoldOut" : "https://schema.org/InStock",
      url: `${SITE_URL}/expeditions/${slug}`,
    };
  }
  return ld;
};
